import axios from "axios";

export default {
    snakeToCamel(str) {
        return str.replace(
            /(?!^)_(.)/g,
            (_, char) => char.toUpperCase()
        );
    },
    import(self) {
        let formData = new FormData();
        formData.append("file", self.file);
        formData.append("isTemporary", true);

        const donorService = this;

        self.isImportProcessed = true;
        self.isImportFail = false;
        self.donors = [];

        axios.post("/pmdd/donorsForm/export", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(function (response) {
                self.donors = response.data.donors;
                if (response.data.status != 0) {
                    const div = document.createElement("div");
                    div.innerHTML = response.data.html_message;
                    div.innerHTML += "<br/> <strong>Ошибочные данные не попадут в систему!</strong>"
                    self.$swal({
                        title: self.$t('Результаты первичной проверки файла'),
                        content: div,
                        className: 'swal-donors-import-check',
                        icon: "warning",
                        buttons: {
                            ok: {
                                className: "btn-primary",
                                text: self.$t('Продолжить импорт'),
                                value: "ok"
                            },
                            copy: {
                                className: "btn-secondary",
                                text: self.$t('Скопировать текст'),
                                value: "copy"
                            },
                            cancel: self.$t('Отказаться')
                        }
                    }).then(value => {
                        switch (value) {
                            case "ok":
                                donorService.importFromLab(self);
                                break;
                            case "cancel":
                                self.isImportProcessed = false;
                                break;
                            case "copy":
                                self.$copyText(response.data.message)
                                    .then(function () {
                                        self.$swal("", self.$t('Текст скопирован'), "success");
                                    },
                                        function () {
                                            self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                        });
                                break;
                        }
                    });
                } else {
                    donorService.importFromLab(self);
                }
                self.isImportProcessed = false;
            })
            .catch(function (response) {
                const div = document.createElement("div");

                div.innerHTML = response.data.html_message;
                self.$swal({
                    title: self.$t('Ошибка'),
                    content: div,
                    icon: "error",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: self.$t('Скопировать')
                        }
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            //window.location.reload();
                            break;
                        case "copy":
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
                self.isImportProcessed = false;
            });
    },
    importFromLab(self) {
        const donorService = this;
        let formData = new FormData();
        let donors = this.snakeToCamel(JSON.stringify(self.donors));
        formData.append("donors", donors);
        formData.append("isTemporary", true);
        self.isImportProcessed = true;
        self.isImportFail = false;
        axios.post("/donors/importFromLab", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(function (response) {
                const div = document.createElement("div");
                if (response.data) {
                    div.innerHTML = response.data.htmlMessage;
                }
                else {
                    div.innerHTML = self.$t('Ошибка соединения');
                }
                self.$swal({
                    title: self.$t('Результаты проверки'),
                    content: div,
                    className: 'swal-donors-import-check',
                    icon: "success",
                    buttons: {
                        ok: {
                            className: "btn-primary",
                            text: self.$t('Выполнить импорт'),
                            value: "ok"
                        },
                        copy: {
                            className: "btn-secondary",
                            text: self.$t('Скопировать текст'),
                            value: "copy"
                        },
                        cancel: self.$t('Отказаться')
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            donorService.realUpload(self);
                            break;
                        case "cancel":
                            self.isImportProcessed = false;
                            break;
                        case "copy":
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
                self.isImportProcessed = false;
            })
            .catch(function (response) {
                const div = document.createElement("div");

                div.innerHTML = response.data.htmlMessage;
                self.$swal({
                    title: self.$t('Ошибка'),
                    content: div,
                    icon: "error",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: self.$t('Скопировать')
                        }
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            //window.location.reload();
                            break;
                        case "copy":
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
                self.isImportProcessed = false;
            });
    },
    activateDonorForms(bmddResponse, caller) {
        for(let i = 0; i < bmddResponse.data.donors.length; i++) {
            bmddResponse.data.donors[i].lab = bmddResponse.data.donors[i].externalId;
        }
        axios.post("/pmdd/donorsForm/activate", bmddResponse.data.donors)
        .then(function (response) {
            caller.hideModal();
            caller.isImportProcessed = false;
            const div = document.createElement("div");
            if (bmddResponse.data) {
                div.innerHTML = bmddResponse.data.htmlMessage;
                div.innerHTML += "<br/>";
                div.innerHTML += "<p>Отправлено <strong> " + response.data.mail_sended_count + " </strong> Email сообщений донорам</p>";
                div.innerHTML += "<p>Отправлено <strong> " + response.data.sms_sended_count + " </strong> SMS сообщений донорам</p>";
            } else {
                div.innerHTML = caller.$t('Ошибка соединения');
            }
            caller.$swal({
                title: caller.$t('Успешный импорт'),
                content: div,
                icon: "success"
            }).then(() => {
                caller.isImportProcessed = false;
                window.location.reload();
            });
        });
    },
    realUpload(self) {
        self.isImportProcessed = true;
        let root = this;
        let formData = new FormData();
        formData.append("isTemporary", false);
        axios.post("/donors/importFromLab", formData)
            .then(function (response) {
                root.activateDonorForms(response, self);
            })
            .catch(function (response) {
                const div = document.createElement("div");
                div.innerHTML = response.data.htmlMessage;
                self.$swal({
                    title: self.$t('Предупреждение'),
                    content: div,
                    icon: "warning",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: self.$t('Скопировать')
                        }
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            self.isImportProcessed = false;
                            break;
                        case "copy":
                            self.isImportProcessed = false;
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
            });
    },
}
